export const fetch = globalThis.fetch;
export const fetchOptions = {};
